var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('i',{staticClass:"iconfont icon-icon-test"}),_vm._v(" 404 No Found "),_c('div',{staticClass:"tips"},[_c('router-link',{attrs:{"to":"/"}},[_c('el-button',{staticStyle:{"font-size":"40px"},attrs:{"type":"text"}},[_vm._v("Back Home")])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }